export default __webpack_public_path__ + "static/logo_google-fd689af2aa6003cd16152f1dc13820de.png";